const trackEvent = (eventName, eventData = {}) => {
    // Send to Plausible
    if (typeof window !== 'undefined' && typeof window.plausible === 'function') {
        window.plausible(eventName, { props: eventData });
    }

    // Send to GTM
    if (typeof window !== 'undefined' && window.dataLayer) {
        window.dataLayer.push({
            event: eventName,
            ...eventData,
        });
    }
};

export default trackEvent;
